import React from "react"
import { Link } from "gatsby"
import funlearning from "../../../images/funlearning-banner.png"
import clock from "../../../images/clock.png"
import StaticVideo from "../../Video/StaticVideo"
import PosterImage from "./../../../images/video-2-poster.png"
import Transcript from "./../../../images/Surf-the-Web-Safely-Transcript.pdf"
import "./BeanoGoingSolo.scss"

const BeanoGoingSolo = () => {
	return (
		<div className="fun-learning learning go-solo">
			<div className="container">
				<div className="row">
					<div className="col-12 col-md-6 order-md-1">
						{/* <img src={funlearning} alt="Fun interactive learning"/> */}
						<div className="video-box-bg text-center">
							<StaticVideo videoId="rmK-1Vf1cv8" poster={PosterImage} transcript={Transcript} engagement={"Grown-up Homepage"}/>
						</div>
					</div>
					<div className="col-12 col-md-6 order-md-0">
						<div className="content">
							<h2 className="h1">GOING SOLO</h2>
							<h4>Surfing the web unsupervised – watch with your kids then share these great tips:</h4>
							<ol>
								<li>Set up web filters so you don’t see things you shouldn’t. On an Apple device, this can be done in your screen time settings. On Android, this can be done on SafeSearch settings.</li>
								<li>If anyone is mean to you, you can mute, block and report them, and tell a responsible adult.</li>
								<li>Your phone can tell where you are, but that means other people on the web may be able to find out too. You should never share your location with strangers – you can turn off your geolocation in settings.</li>
							</ol>
							{/* <p>Get your kids ready for their online adventures with the EE PhoneSmart Licence.</p> */}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default BeanoGoingSolo
